/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Rahul Bagaria' <Rahul@wakencode.com>, September 2022
 *
 *****************************************************************************/

import { AntLayout, AntMenu } from "../../antd";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import { ROUTES, RoutesEnum } from "../../../model/constants/routes";
import React, { memo } from "react";

import { HeaderContent } from "../header";
import type { MenuProps } from "antd";

import { theme } from "antd";

import Routes from "../../routes";
import { useNavigate } from "react-router-dom";

// Header, Sider and Content Exported from Ant Design Layout
const { Header, Sider, Content } = AntLayout;

type MenuItem = Required<MenuProps>["items"][number];

export const getItem = (
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem => {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
};

// AntMenu Item and there sub menu
const items: MenuItem[] = [
  getItem(RoutesEnum.ABOUT, ROUTES.ABOUT_US, <InfoCircleOutlined />),
];

/**
 * Functional Component that return layout for web app
 *
 * @returns JSX for layout of web app
 */
export const Layout = memo(() => {
  const navigate = useNavigate();

  const handleMenuSelection = (key: string) => {
    if (key === ROUTES.ABOUT_US) {
      window.open(process.env.REACT_APP_WEBSITE);
    } else

    navigate(key);
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <>
      <AntLayout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <HeaderContent />
        </Header>
        <AntLayout style={{ height: "90vh" }}>
          {/* <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {
              console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              console.log(collapsed, type);
            }}
          >            
            <AntMenu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={["1"]}
              items={items}
              onSelect={({ key }) => handleMenuSelection(key)}
            />
          </Sider> */}

          {/* Header section */}
          <Content style={{ margin: "12px 16px 0",overflow: 'auto'  }}>
            <div
              style={{
                padding: 12,
                background: colorBgContainer,
              }}
            >
              <Routes />
            </div>
          </Content>
          {/* <Footer style={{ textAlign: "center" }}>
            ServiceActivator Inc ©2023. All Rights Reserved.
          </Footer> */}
        </AntLayout>
      </AntLayout>
    </>
  );
});
